<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <HeadlineContainer :headline="topic.attributes.name" :breadcrumbs="[{text: 'Topics'},{text: topic.attributes.name}]"/>

      <div class="container">
        <DailyChart :topic="topic"/>

        <OverviewPanel :topic="topic"/>

        <ArticleTable :topic="topic"/>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import HeadlineContainer from "../../../components/Layout/HeadlineContainer.vue";
import LoadingContainer from "../../../components/Layout/LoadingContainer.vue";
import DailyChart from "./Panels/DailyChart.vue";
import OverviewPanel from "./Panels/OverviewPanel.vue";
import ArticleTable from "./Panels/ArticleTable.vue";

export default {
  components: {ArticleTable, OverviewPanel, DailyChart, LoadingContainer, HeadlineContainer},

  data() {
    return {
      topic: null,
      loading: true,
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/content-topics/' + this.$route.params.topicId).then(response => {
        this.topic = response.data.data

        this.loading = false
      })
    },
  }
}
</script>
